// src/pages/Projects.js
import React from 'react';
import '../styles/projects.css';
import { Link } from 'react-router-dom';

const projectData = [
  {
    title: "Talent-Based Curriculum",
    description: "A curriculum designed to identify and develop students' unique talents.",
    link: "/talent-based-curriculum",
  },
  {
    title: "Giant Teacher",
    description: "An innovative approach to education that leverages technology to enhance learning.",
    link: "/giant-teacher",
  },
  {
    title: "Venting Room",
    description: "A safe space for students to express their feelings and receive support.",
    link: "/venting-room",
  },
  {
    title: "Freelance",
    description: "Programs designed to equip students with freelance skills.",
    link: "/freelance",
  },
  {
    title: "Entrepreneurship",
    description: "Programs to foster entrepreneurial skills and mindset in students.",
    link: "/entrepreneurship",
  },
  {
    title: "STEM Subjects",
    description: "Enroll in STEM tutoring and access interactive learning resources.",
    link: "/stem-subjects",
  },
];

const Projects = () => {
  return (
    <div className="projects-container">
      <h1>Our Projects</h1>
      <div className="projects-grid">
        {projectData.map((project, index) => (
          <div key={index} className="project-card">
            <Link to={project.link} className="project-link">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
